import { GlobalContext } from '../../utils/globalprovider.js';

import {
  forwardRef,
  useCallback,
  useContext,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react';

import './table-caracteres.css';

import { flatMapDeep, padStart, uniqBy } from 'lodash';

const TableCaracteres = forwardRef((props, ref) => {
  const context = useContext(GlobalContext);
  const lang = context.language;

  const [data, setData] = useState([]);
  const [subsets, setSubsets] = useState([]);
  const [selectedSubset, setSelectedSubset] = useState('');
  const [search, setSearch] = useState('');

  const charactersData = useMemo(() => {
    if (!data) {
      return [];
    }

    if (search) {
      const list = flatMapDeep(data.map((x) => x.characters));

      const listFiltered = uniqBy(
        list.filter((x) =>
          (lang === 'fr' ? x.fr : x.en).toLowerCase().includes(search)
        ),
        (x) => x.unicode
      );

      return listFiltered;
    }

    const characters = data.find((x) => x.name === selectedSubset)?.characters;
    return characters;
  }, [data, search, lang, selectedSubset]);

  const hexToDecimal = (hex) => parseInt(hex, 16);

  const getSubset = (ch) => {
    
  }

  useImperativeHandle(ref, () => ({
    setTableCaracteres(items) {
      setData(items);

      const subsetsList = items.map((x) => {
        return {
          name: x.name,
          fr: x.fr,
          en: x.en,
        };
      });

      setSubsets(subsetsList);
      setSelectedSubset('courant');
    },

  }));

  const onInputKeyDown = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    const setCursorPosition = (inputElement, position) => {
      setTimeout(() => {
        inputElement.setSelectionRange(position, position);
        inputElement.scrollLeft = inputElement.scrollWidth;
        inputElement.focus();
      }, 0);
    };
    
    const updateText = (input, value, start, end) => {
      setSearch(value);

      // Ensure input stays focused after update
      setTimeout(() => {
        setCursorPosition(input, start);
      }, 0);
    };

    const onBackspace = (input) => {
      let start = input.selectionStart;
      let end = input.selectionEnd;

      const text = search;
      const value = text.substring(0, start - 1) + text.substring(end);

      updateText(input, value, start - 1, end);
    };

    const onDelete = (input) => {
      let start = input.selectionStart;
      let end = input.selectionEnd;

      const text = search;
      const value = text.substring(0, start) + text.substring(end + 1);

      updateText(input, value, start, end);
    };
    
    const input = event.target;

    if (event.ctrlKey) {
      if (event.key === 'a') {
        input.setSelectionRange(0, input.value.length);
        return;
      }

      if (event.key === 'ArrowLeft') {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        if (start === 0) return;

        input.setSelectionRange(start - 1, end);
        return;
      }

      if (event.key === 'ArrowRight') {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        if (end === input.value.length) return;

        input.setSelectionRange(start, end + 1);
        return;
      }
    }

    if (event.key === 'ArrowLeft') {
      if (input.selectionStart === 0) return;

      setCursorPosition(input, input.selectionStart - 1);
      return;
    }

    if (event.key === 'ArrowRight') {
      if (input.selectionStart === input.value.length) return;

      setCursorPosition(input, input.selectionStart + 1);
      return;
    }

    if (event.key === 'Home') {
      setCursorPosition(input, 0);
      return;
    }

    if (event.key === 'End') {
      setCursorPosition(input, input.value.length);
      return;
    }

    if (event.key === 'Backspace') {
      onBackspace(input);
      return;
    }

    if (event.key === 'Delete') {
      onDelete(input);
      return;
    }

    var char = event.key;
    if (char.length > 1) {
      return;
    }

    let start = input.selectionStart;
    let end = input.selectionEnd;
    const text = search;
    const value = text.substring(0, start) + char + text.substring(end);
    updateText(input, value, start + 1, end);
  }, [search]);

  return (
    <>
      <div className="table-caracteres">
        <div className="header">
          <div className="liste">
            <label htmlFor="lstSousEnsemble">
              {lang === 'fr' ? 'Sous-ensemble' : 'Subset'}
            </label>
            <select
              id="lstSousEnsemble"
              value={selectedSubset}
              onChange={(e) => setSelectedSubset(e.target.value)}
              disabled={search !== ''}
            >
              {subsets.map((sub) => (
                <option key={sub.name} value={sub.name}>
                  {lang === 'fr' ? sub.fr : sub.en}
                </option>
              ))}
            </select>
          </div>
          <div className="search-char">
            <label htmlFor="txtSearchChar">
              {lang === 'fr' ? 'Rechercher' : 'Search'}
            </label>
            <input
              type="text"
              id="txtSearchChar"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={onInputKeyDown}
              autoComplete='off'
            ></input>
          </div>
        </div>
        <div className="characters">
          {charactersData?.map((ch, index) => {
            const decimalValue = hexToDecimal(ch.unicode);
            const charString = String.fromCharCode(decimalValue) ?? ch.char;

            return (
              <div key={`${ch.unicode}_${index}`} className="unicode">
                <button
                  type="button"
                  className="unicode-string"
                  title={lang === 'fr' ? ch.fr : ch.en}
                  onClick={() => props.onSubmitChar(ch)}
                >
                  <span>{charString}</span>
                </button>
                <p className="unicode-decimal">
                  {padStart(decimalValue, 4, 0)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
});

export default TableCaracteres;
